import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

import * as MediaUpload from './MediaUpload';

export type V = {
  '@id': string;
  '@type': 'Appointment';
  clinician: {
    '@id': string;
    '@type': 'User';
    name: string | null;
    clinicianProfile: {
      '@id': string;
      '@type': 'UserClinicianProfile';
      type: string;
    } | null;
    displayPicture: MediaUpload.BaseView | null;
  };
  startAt: string;
  status: string;
  zoomLink: string | null;
  duration: number;
};

export type V_ClinicianSub = {
  '@id': string;
  '@type': 'Appointment';
  id: string;
  user: {
    '@id': string;
    '@type': 'User';
    id: string;
    name: string | null;
  };
  startAt: string;
  zoomLink: string | null;
  userAppointmentCount: number | null;
  duration: number;
};

export type V_Create = {
  '@id': string;
  '@type': 'Appointment';
  appointment: {
    '@id': string;
    '@type': 'Appointment';
    id: string;
    clinician: {
      '@id': string;
      '@type': 'User';
      name: string | null;
      displayPicture: MediaUpload.BaseView | null;
    };
    startAt: string;
    status: string;
  } | null;
  paymentIntent: string | null;
  ephemeralKey: string | null;
  stripeCustomerId: string | null;
  publishableKey: string | null;
  appointmentId: string | null;
  totalToPay: number | null;
  stripeVersion: string | null;
};

export type V_Reschedule = {
  '@id': string;
  '@type': 'Appointment';
  startAt: string;
};

export type W = {
  clinician: string;
  startAt: string;
  purchaseType: string | null;
};

export type W_Reschedule = {
  startAt: string;
};

export function useReadCollectionAppointmentsStartDateEndDate(
  id: string,
  startDate: string,
  endDate: string,
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_ClinicianSub>>(
    `/clinicians/${id}/appointments/${startDate}/${endDate}`,
    options,
  );
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<V>(`/appointments/${id}`, options);
}
